/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { ClientCompany } from 'walden-fast/types/fast-backend/user';

export interface WaldenGreenReportDownloadSignature {
  Args: {
    clients: ClientCompany[];
    years: number[];
    isLoading: boolean;
    hasError: boolean;
    onDownload: (year: number, client: ClientCompany) => void;
    onDismissError: () => void;
  };
  Element: HTMLDivElement;
}

export default class WaldenGreenReportDownload extends Component<WaldenGreenReportDownloadSignature> {
  @tracked selectedClient: ClientCompany | null = null;
  @tracked selectedYear: number | null = null;

  get isValid() {
    return this.selectedYear !== null && this.selectedClient !== null;
  }

  @action
  updateClient(selected: unknown) {
    this.selectedClient = selected as ClientCompany;
  }

  @action
  updateYear(selected: unknown) {
    this.selectedYear = selected as number;
  }

  @action
  download() {
    this.args.onDownload(this.selectedYear!, this.selectedClient!);
  }
}
